/**
 * Kanimozhi / DMK Media Catalogue
 *
 * Visual configurations and talking points for senior DMK leader and MP Kanimozhi Karunanidhi.
 */

const wiki = (filename) =>
  `https://en.wikipedia.org/wiki/Special:FilePath/${encodeURIComponent(filename)}`;

/* ─── Portrait of Kanimozhi Karunanidhi (Only tracked leader) ─────────── */
export const TDP_PORTRAITS = [
  {
    id: 'portrait-primary',
    src: '/kanimozhi.jpg',
    alt: 'Kanimozhi Karunanidhi — Member of Parliament',
    caption: 'Kanimozhi Karunanidhi',
  },
];

/* The "hero" image used across the app (login, header, dashboard avatar). */
export const TDP_HERO = TDP_PORTRAITS[0];

/* ─── Tamil Nadu gallery imagery ────────────────────────── */
export const AP_GALLERY = [
  {
    id: 'tn-marina',
    src: wiki('Marina Beach, Chennai, Tamil Nadu.jpg'),
    alt: 'Marina Beach, Chennai',
    caption: 'Marina Beach · Chennai',
  },
  {
    id: 'tn-madurai',
    src: wiki('Madurai Meenakshi Temple, Tamil Nadu.jpg'),
    alt: 'Meenakshi Temple, Madurai',
    caption: 'Meenakshi Temple · Madurai',
  },
  {
    id: 'tn-thoothukudi',
    src: wiki('Our Lady of Snows Basilica, Thoothukudi.jpg'),
    alt: 'Snows Basilica, Thoothukudi',
    caption: 'Snows Basilica · Thoothukudi',
  },
];

/* ─── DMK party visual marks ─────────────────────────────────────── */
export const TDP_MARK = {
  flag: '/DMK.jpg',
};

/* ─── Local fallback served from /public ────────────────────────── */
export const LOCAL_FALLBACK = '/policelogo.jpg';

/* ─── Key DMK / Kanimozhi constituencies in Tamil Nadu ─────────────── */
export const TDP_KEY_CONSTITUENCIES = [
  { name: 'Thoothukudi',   district: 'Thoothukkudi' },
  { name: 'Madurai Central', district: 'Madurai' },
  { name: 'Katpadi',       district: 'Vellore' },
  { name: 'Harbour',       district: 'Chennai' },
  { name: 'Karur',         district: 'Karur' },
  { name: 'Omalur',        district: 'Salem' },
];

/* ─── Talking-points the DMK champions ─────────────────── */
export const TDP_FOCUS_TOPICS = [
  'Social Justice & Equality',
  'State Autonomy & Federalism',
  'Dravidian Model governance',
  'Thoothukudi local welfare & infrastructure',
  'Women empowerment & education',
  'Tamil language rights',
  'IT & industrial growth in South TN',
  'Farmer welfare & irrigation',
];
